import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const DefaultIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="AgentsOutlineIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/agents/outline">
            <g id="Vector">
                <path
                    d="M15.5357 11.2932C15.3482 11.4807 15.2429 11.735 15.2429 12.0002C15.2429 12.2653 15.3482 12.5197 15.5357 12.7072L17.9117 15.0842C18.0992 15.2717 18.3535 15.377 18.6187 15.377C18.8839 15.377 19.1382 15.2717 19.3257 15.0842L21.7027 12.7072C21.8902 12.5197 21.9955 12.2653 21.9955 12.0002C21.9955 11.735 21.8902 11.4807 21.7027 11.2932L19.3257 8.91618C19.1382 8.72871 18.8839 8.62339 18.6187 8.62339C18.3535 8.62339 18.0992 8.72871 17.9117 8.91618L15.5357 11.2932Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                >
                </path>
                <path
                    d="M2.29669 11.2932C2.10922 11.4807 2.00391 11.735 2.00391 12.0002C2.00391 12.2653 2.10922 12.5197 2.29669 12.7072L4.67369 15.0842C4.86122 15.2717 5.11553 15.377 5.38069 15.377C5.64586 15.377 5.90016 15.2717 6.08769 15.0842L8.46469 12.7072C8.65216 12.5197 8.75748 12.2653 8.75748 12.0002C8.75748 11.735 8.65216 11.4807 8.46469 11.2932L6.08769 8.91618C5.90016 8.72871 5.64586 8.62339 5.38069 8.62339C5.11553 8.62339 4.86122 8.72871 4.67369 8.91618L2.29669 11.2932Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                >
                </path>
                <path
                    d="M8.91569 17.9122C8.82272 18.0051 8.74896 18.1153 8.69863 18.2367C8.64831 18.3581 8.62241 18.4883 8.62241 18.6197C8.62241 18.7511 8.64831 18.8812 8.69863 19.0026C8.74896 19.124 8.82272 19.2343 8.91569 19.3272L11.2927 21.7032C11.4802 21.8907 11.7345 21.996 11.9997 21.996C12.2649 21.996 12.5192 21.8907 12.7067 21.7032L15.0837 19.3272C15.1767 19.2343 15.2504 19.124 15.3008 19.0026C15.3511 18.8812 15.377 18.7511 15.377 18.6197C15.377 18.4883 15.3511 18.3581 15.3008 18.2367C15.2504 18.1153 15.1767 18.0051 15.0837 17.9122L12.7067 15.5362C12.5192 15.3487 12.2649 15.2434 11.9997 15.2434C11.7345 15.2434 11.4802 15.3487 11.2927 15.5362L8.91569 17.9122Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                >
                </path>
                <path
                    d="M8.91569 4.67418C8.72822 4.86171 8.62291 5.11602 8.62291 5.38118C8.62291 5.64635 8.72822 5.90065 8.91569 6.08818L11.2927 8.46418C11.4802 8.65165 11.7345 8.75697 11.9997 8.75697C12.2649 8.75697 12.5192 8.65165 12.7067 8.46418L15.0837 6.08818C15.2712 5.90065 15.3765 5.64635 15.3765 5.38118C15.3765 5.11602 15.2712 4.86171 15.0837 4.67418L12.7067 2.29718C12.5192 2.10971 12.2649 2.00439 11.9997 2.00439C11.7345 2.00439 11.4802 2.10971 11.2927 2.29718L8.91569 4.67418Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                >
                </path>
            </g>
        </g>
    </SvgIcon>
)
